var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-menubar"},[_c('div',{staticClass:"layout-menubar-activeModule"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_c('div',{staticClass:"layout-menubar-menuList"},[_vm._t("menu",function(){return [_c('menu-list',{attrs:{"menus":_vm.menus,"selected":_vm.selected,"on-click":_vm.onClick}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }